module.exports = __webpack_public_path__ + "static/media/DT5.564fc259.jpg";